/**
 * @name 版本过渡方法
 * @description 每次更新，需要替换为最新版本号的过渡脚本，保证线上数据不受影响
 * @params { Object } formData 表单数据
 * @returns { Object } 过渡之后的数据
 * @author liuguisheng
 * @version 2010-1-1
 * 
*/

import * as currentVersion from './v014.js';

export const upgrade = function (formData) {
    return currentVersion.upgrade(formData);
}


// WEBPACK FOOTER //
// ./src/assets/version/version.js